import config from '@/config'

export default {
  combine: {
    confirm_password: "Xác nhận mật khẩu",
    change_password: "Thay đổi mật khẩu",
    old_password: "Cũ @:ui.password",
    new_password: "@:ui.new @:ui.password",
    confirm_security_code: "Xác nhận @:ui.security_code",
    first_time_login: "Đăng nhập lần đầu tiên",
    security_authentication: "Xác thực bảo mật",
    update_security: "Cập nhật bảo mật",
    disable_security: "Vô hiệu hóa bảo mật",
    add_account: "Thêm tài khoản",
    add_sub_account: "Thêm tài khoản phụ",
    edit_operator: "Chỉnh sửa toán tử",
    edit_account: "Chỉnh sửa tài khoản",
    edit_member: "Chỉnh sửa thành viên",
    approve_ticket: "Phê duyệt vé",
    reject_ticket: "Từ chối vé",
    add_bank_account: "Thêm tài khoản ngân hàng",
    edit_bank_account: "Chỉnh sửa tài khoản ngân hàng",
    reset_threshold: "Đặt lại ngưỡng",
    adjust_balance: "Điều chỉnh cân bằng",
    adjust_member: "Điều chỉnh thành viên",
    configure_bank_setting: "Định cấu hình cài đặt ngân hàng",
    account_setup: "Thiết lập tài khoản",
    bank_transfer: "Chuyển khoản ngân hàng",
    edit_bank_member: "Chỉnh sửa thành viên ngân hàng",
    edit_ticket: "Chỉnh sửa vé",
    edit_vip: "Chỉnh sửa VIP",
    knock_off_promo: "Quảng cáo nhái",
    edit_authority: "Thẩm quyền chỉnh sửa",
    reset_password: "Đặt lại mật khẩu",
    update_password: "Cập nhật mật khẩu",
    member_summary: "Tóm tắt thành viên",
    reply_review: "Trả lời đánh giá",
    edit_affiliate: "Chỉnh sửa đại lý",
    edit_bank_affiliate: "Chỉnh sửa đại lý ngân hàng",
    approve_affiliate_ticket: "Phê duyệt phiếu đại lý",
    check_free_spin: "Kiểm tra vòng quay miễn phí",
    reject_affiliate_ticket: "Từ chối phiếu đại lý",
    wallet_adjust: "Điều chỉnh ví",
    update_comm_package: "Cập nhật gói truyền thông",
    approve_affiliate: "Đại lý phê duyệt",
    sub_acc_detail_affiliate: "Đại lý chi tiết tài khoản phụ",
    get_tac: "Nhận OTP",
    add_coupon: "Thêm phiếu giảm giá",
    update_coupon: "Cập nhật phiếu giảm giá",
    issue_free_spin: "Phát hành vòng quay miễn phí",
    get_bank_tac: "Nhận mã OTP ngân hàng",
    update_global_setting: "Cập nhật cài đặt chung",
    add_platform: "Thêm nền tảng",
    edit_platform: "Chỉnh sửa nền tảng",
    add_bank_group: "Thêm nhóm ngân hàng",
    edit_bank_group: "Chỉnh sửa nhóm ngân hàng",
    update_maintenance_schedule: "Cập nhật lịch bảo trì",
    add_withdrawal_limit: "Thêm giới hạn rút tiền",
    edit_withdrawal_limit: "Chỉnh sửa giới hạn rút tiền",
    add_campaign: "Thêm chiến dịch",
    edit_campaign: "Chỉnh sửa chiến dịch",
    add_promo_group: "Thêm nhóm khuyến mãi",
    edit_promo_group: "Chỉnh sửa nhóm khuyến mãi",
    update_team: "Cập nhật đội",
    update_result: "Cập nhật kết quả",
    insert_result: "Chèn kết quả",
    bet_list: "Danh sách đặt cược",
    result_list: "Danh sách kết quả",
    add_promo: "Thêm khuyến mãi",
    raise_deposit_ticket: "Nâng vé đặt cọc",
    bank_adjust: "Điều chỉnh ngân hàng",
    promo_member_assign: "Chỉ định thành viên khuyến mãi",
    bonus_issue: "Vấn đề tiền thưởng",
    update_vip: "Cập nhật VIP",
    update_member_profile: "Cập nhật hồ sơ thành viên",
    change_withdrawal_limit: "Thay đổi giới hạn rút tiền",
    change_bank_group: "Thay đổi nhóm ngân hàng",
    change_promotion_group: "Nhóm Khuyến mãi Thay đổi",
    edit_promo_signup: "Chỉnh sửa đăng ký khuyến mãi",
    update_provider_bet_limit: "Cập nhật giới hạn đặt cược nhà cung cấp",
    update_bet_limit: "Cập nhật giới hạn cược",
    update_member_bet_limit: "Cập nhật giới hạn đặt cược thành viên",
    edit_bank_account_group: "Chỉnh sửa nhóm tài khoản ngân hàng",
    redeposit_ticket: "Nạp lại vé",
    edit_promotion_group: "Chỉnh sửa nhóm khuyến mãi",
    edit_promotion_group_norm: "Quản lý khuyến mãi trong nhóm",
    get_inbox_list: "Nhận danh sách hộp thư đến",
    view_result_changes_detail: "Xem chi tiết thay đổi kết quả",
    edit_promotion_signup: "Chỉnh sửa đăng ký khuyến mãi",
    edit_bet_limit: "Chỉnh sửa giới hạn đặt cược",
    edit_provider_game_off: "Tắt trò chơi chỉnh sửa nhà cung cấp",
    edit_provider_rtp: "Chỉnh sửa RTP của nhà cung cấp",
    get_rebate: "Nhận chiết khấu",
    get_recent_deposit: "Nhận khoản tiền gửi gần đây",
    add_survey: "Thêm khảo sát",
    add_announcement_banner: "Thêm biểu ngữ thông báo",
    edit_announcement_banner: "Chỉnh sửa biểu ngữ thông báo",
    move_announcement_banner: "Di chuyển biểu ngữ thông báo",
    add_promotion_banner: "Thêm biểu ngữ khuyến mãi",
    edit_promotion_banner: "Chỉnh sửa biểu ngữ khuyến mãi",
    unlink_banner: "Hủy liên kết",
    move_promotion_banner: "Di chuyển biểu ngữ khuyến mãi",
    add_slide_banner: "Thêm biểu ngữ trang chiếu",
    edit_slide_banner: "Chỉnh sửa biểu ngữ trang chiếu",
    move_slide_banner: "Di chuyển biểu ngữ trang chiếu",
    add_seo_page: "Thêm trang SEO",
    edit_seo_page: "Chỉnh sửa trang SEO",
    clear_outstanding: "Xuất sắc rõ ràng",
    add_ip_whitelist: "Thêm danh sách trắng IP",
    bonus_issue_bulk: "Vấn đề tiền thưởng hàng loạt",
    edit_bank_member_ewallet: "Chỉnh sửa thành viên ngân hàng (Ví điện tử)",
    redeposit: "Nạp lại",
    reject_approved_ticket: "Từ chối vé được phê duyệt",
    audit_ticket: "Phiếu kiểm toán",
    review_ticket: "Vé đánh giá",
    edit_promotion_group_norm_seq: "Quản lý trình tự thăng tiến trong nhóm",
    edit_promo_provider_list: "Chỉnh sửa danh sách nhà cung cấp dịch vụ khuyến mãi",
    edit_promo_payment_option: "Chỉnh sửa tùy chọn thanh toán khuyến mãi",
    edit_campaign_provider_list: "Chỉnh sửa danh sách nhà cung cấp chiến dịch",
    update_comm: "Hoa hồng cập nhật",
    update_carry_over: "Cập nhật chuyển tiếp",
    review_affiliate_ticket: "Đánh giá vé đại lý",
    audit_affiliate_ticket: "Phiếu đại lý kiểm toán",
    get_tac_affiliate: "Nhận OTP (Đại lý)",
    raise_deposit_ticket_gateway: "Raise Deposit Ticket (Gateway)",
    direct_audit_ticket: "Phiếu kiểm toán (Trực tiếp)",
    get_rollback_detail: "Nhận chi tiết khôi phục",
    get_reject_detail: "Nhận chi tiết từ chối",
    manual_approve_ticket: "Phê duyệt vé (Hướng dẫn sử dụng)",
    add_label: "Thêm nhãn",
    edit_label: "Chỉnh sửa nhãn",
    rollback_processing_ticket: "Phiếu xử lý khôi phục",
    update_iframe_url: "Cập nhật URL Iframe",
    edit_exchange_rate: "Chỉnh sửa tỷ giá hối đoái",
    add_vip: "Thêm VIP",
    add_turnover_tier: "Thêm cấp doanh thu",
    edit_turnover_tier: "Chỉnh sửa Bậc Doanh thu",
    edit_mission_reward: "Chỉnh sửa phần thưởng nhiệm vụ",
    enable_mission_reward: "Bật phần thưởng nhiệm vụ",
    get_member_label_list: "Danh sách nhãn thành viên",
    add_rescue_fund: "Thêm quỹ cứu hộ",
    get_custom_member_list: "Danh sách thành viên tùy chỉnh",
    get_rescue_fund_provider: "Nhận nhà cung cấp quỹ cứu hộ",
    add_game_exclude: "Thêm loại trừ trò chơi",
    delete_game_exclude: "Xóa loại trừ trò chơi",
    domain_custom_add_assign: "Thêm tên miền",
    add_domain_batch: "Thêm tên miền (Batch)",
    update_payment_provider_vip: "Cập nhật VIP của nhà cung cấp dịch vụ thanh toán",
    update_campaign: "Cập nhật chiến dịch",
    purchase_domain: "Mua tên miền",
    apply_domain: "Áp dụng tên miền",
    edit_access_control: "Chỉnh sửa kiểm soát truy cập",
    add_domain: "Thêm miền",
    operator_wallet_adjust: "Ví Operator Adjust",
    update_payment_provider_desc: "Cập nhật mô tả nhà cung cấp dịch vụ thanh toán",
    add_package: "@:ui.add @:ui.package",
    edit_package: "@:ui.edit @:ui.package",
    add_theme_content: "@:ui.thêm @:ui.theme_content",
    edit_theme_content: "@:ui.edit @:ui.theme_content",
    add_theme: "@:ui.add @:ui.theme",
    edit_theme: "@:ui.edit @:ui.theme",
    add_color: "@:ui.add @:ui.color",
    edit_color: "@:ui.edit @:ui.color",
    add_content: "@:ui.add @:ui.content",
    edit_content: "@:ui.edit @:ui.content",
    delete_content: "@:ui.delete @:ui.content",
    update_setting: "@:ui.update @:ui.setting",
    add_theme_content_group: "@:ui.add @:ui.theme_content_group",
    edit_theme_content_group: "@:ui.edit @:ui.theme_content_group",
    add_bo_default_domain: "@:ui.add @:ui.bo_default_domain",
    edit_bo_default_domain: "@:ui.edit @:ui.bo_default_domain",
    update_theme: "@:ui.update @:ui.theme",
    update_menu: "@:ui.update @:ui.menu",
    update_game_menu: "@:ui.update @:ui.game_menu",
    update_special_menu: "@:ui.update @:ui.special_menu",
    update_setting_menu: "@:ui.update @:ui.setting_menu",
    update_profile_setting: "@:ui.update @:ui.profile_setting",
    update_operator_setting: "@:ui.update @:ui.operator_setting",
    add_social_account: "@:ui.add @:ui.social_account",
    edit_social_account: "@:ui.edit @:ui.social_account",
    add_site_info: "@:ui.add @:ui.site_info",
    edit_site_info: "@:ui.edit @:ui.site_info",
    add_ads: "@:ui.add @:ui.advertisement",
    edit_ads: "@:ui.edit @:ui.advertisement",
    edit_provider_hot_game: "@:ui.edit @:ui.provider @:ui.hot_game",
    edit_provider_new_game: "@:ui.edit @:ui.provider @:ui.new_game",
    edit_provider_popular_game: "@:ui.edit @:ui.provider @:ui.popular_game",
    edit_provider_featured_game: "@:ui.edit @:ui.provider @:ui.featured_game",
    setup_logo: "Logo thiết lập",
    add_livechat: "@:ui.thêm @:ui.livechat",
    update_livechat: "@:ui.update @:ui.livechat",
    provider_pt_operator_update: "Cập nhật nhà điều hành PT của nhà cung cấp",
    provider_pt_global_update: "Cập nhật toàn cầu của nhà cung cấp PT",
    payment_option_callback_update: "Cập nhật URL gọi lại",
    change_payment_option_seq: "Trình tự tùy chọn thanh toán",
    change_payment_mode_status: "Cập nhật trạng thái tùy chọn thanh toán",
    change_payment_option_recommend: "Đề xuất tùy chọn thanh toán",
    change_payment_option_credential: "Thông tin xác thực tùy chọn thanh toán",
    change_payment_option_limit: "Giới hạn tùy chọn thanh toán",
    change_payment_option_vip: "Tùy chọn thanh toán VIP",
    add_mini_game: "@:ui.add @:ui.mini_game",
    edit_mini_game: "@:ui.edit @:ui.mini_game",
    add_mini_game_template: "@:ui.add @:ui.mini_game_template",
    edit_mini_game_template: "@:ui.edit @:ui.mini_game_template",
    edit_reward: "@:ui.edit @:ui.reward",
    gamify_update: "@:ui.update @:ui.reward",
    add_free_game_token: "@:ui.add @:ui.free_game_token",
    add_partners: "@:ui.add @:ui.partners",
    edit_partners: "@:ui.edit @:ui.partners",
    add_leaderboard: "@:ui.add @:ui.leaderboard",
    edit_leaderboard: "@:ui.edit @:ui.leaderboard",
    add_phone: "@:ui.add @:ui.phone",
    adjust_free_balance: "Adjust Free Balance",
    edit_ai_assistant: "@:ui.edit @:ui.ai_assistant",
    change_payment_option_desc: "Mô tả tùy chọn thanh toán",
    fund_transfer_provider: "Nhà Cung Cấp Chuyển Tiền",
    manual_deposit: "Nạp Thủ Công",
    change_linkage_desc: "Mô tả liên kết",
    change_linkage_risk_weight: "Trọng số rủi ro liên kết",
    add_promo_voucher: "@:ui.add @:ui.promotion_voucher",
    edit_promotion_voucher_end_date: "@:ui.edit @:ui.promotion_voucher @:ui.end_date",
    get_voucher_custom_member_list: "Lấy danh sách thành viên tùy chỉnh của voucher",
    redeposit_ticket_voucher: "Nạp lại voucher ticket",
    approve_ticket_voucher: "Phê duyệt voucher ticket",
    reject_ticket_voucher: "Từ chối voucher ticket",
    raise_deposit_ticket_voucher: "Tạo voucher ticket nạp tiền",
    raise_deposit_ticket_voucher_gateway: "Tạo voucher ticket nạp tiền (gateway)",
    get_voucher_list: "Lấy danh sách voucher",
    get_message_list: "Lấy danh sách tin nhắn",
    edit_free_credit: "@:ui.edit @:ui.free_credit",
    knock_off_free_credit_member: "Hủy thành viên tín dụng miễn phí",
    free_credit_manual_assign: "Gán thủ công tín dụng miễn phí",
    review_fcp_ticket: "Xem xét ticket nhà cung cấp tín dụng miễn phí",
    audit_fcp_ticket: "Kiểm toán ticket nhà cung cấp tín dụng miễn phí",
    reject_fcp_ticket: "Từ chối ticket nhà cung cấp tín dụng miễn phí",
    approve_fcp_ticket: "Phê duyệt ticket nhà cung cấp tín dụng miễn phí",
    edit_trigger: "Chỉnh sửa Trigger",
    edit_trigger_status: "Chỉnh sửa trạng thái Trigger",
    adjust_voucher_balance: "Điều chỉnh số dư Voucher",
    clear_free_credit: "Xóa Free Credit",
    add_deposit_tier: "Thêm cấp độ nạp tiền",
    edit_deposit_tier: "Chỉnh sửa cấp độ nạp tiền",
    add_leaderboard_banner: "Thêm Banner Bảng Xếp Hạng",
    edit_leaderboard_banner: "Chỉnh sửa Banner Bảng Xếp Hạng",
    add_referral_banner: "Thêm Banner Giới Thiệu",
    edit_referral_banner: "Chỉnh sửa Banner Giới Thiệu",
    edit_vip_icon: "Chỉnh sửa biểu tượng VIP",
    add_reward_rain: "Thêm Reward Rain",
    edit_reward_rain: "Chỉnh sửa Reward Rain",
    add_reward_rain_session: "Thêm Phiên Reward Rain",
    edit_reward_rain_session: "Chỉnh sửa Phiên Reward Rain",
    edit_reward_rain_session_end_date: "Chỉnh sửa ngày kết thúc Phiên Reward Rain",
    add_news: "Thêm Tin tức",
    edit_news: "Chỉnh sửa Tin tức",
  },
  short: {
    deposit_amount: "Số tiền gửi",
    base_amount: "Số tiền cơ bản",
    bonus_amount: "Số tiền thưởng",
    target_amount: "Số tiền mục tiêu",
    knockoff_by: "K.O Bởi",
    knockoff_date: "Ngày K.O",
    incoming_threshold: "Ngưỡng đến",
    incoming_frequency: "Tần số đến",
    outgoing_threshold: "Ngưỡng đi",
    outgoing_frequency: "Tần số đi",
    account_balance: "Số dư tài khoản",
    claim_type: "Loại yêu cầu",
    bonus_rate: "Tỷ lệ thưởng",
    max_bonus: "Tiền thưởng tối đa",
    rollover: "Lật xe",
    criteria: "Tiêu chí",
    start_time: "Thời gian bắt đầu",
    end_time: "Thời gian kết thúc",
    monday: "Thứ Hai",
    tuesday: "Thứ ba",
    wednesday: "Thứ tư",
    thursday: "Thứ năm",
    friday: "Thứ sáu",
    saturday: "Thứ bảy",
    sunday: "Chủ nhật",
    status: "Trạng thái",
    bonus_rate_percent: "Tỷ lệ thưởng (%)",
    valid_turnover: "Doanh thu hợp lệ",
    deposit_count: "Số lượng tiền gửi",
    withdrawal_amount: "Số tiền rút",
    withdrawal_count: "Số lần rút tiền",
    adjustment_amount: "Số tiền điều chỉnh",
    referee_count: "Đếm trọng tài",
    signup_count: "Số lượng đăng ký",
    verified_count: "Số lượng đã được xác minh",
    active_member: "Thành viên tích cực",
    ftd_count: "Đếm FTD",
    ftd_amount: "FTD Amt",
    working_date: "Ngày làm việc",
    recipient_bank_id: "ID ngân hàng người nhận",
    recipient_bank_acc_no: "Số tài khoản ngân hàng nhận",
    recipient_bank_acc_holder: "Chủ sở hữu tài khoản ngân hàng người nhận",
    sender_bank: "Ngân hàng người gửi",
    sender_bank_acc_no: "Số tài khoản ngân hàng người gửi",
    sender_bank_acc_holder: "Chủ sở hữu tài khoản ngân hàng người gửi",
    unique_login_count: "Số lần đăng nhập duy nhất",
    unique_deposit_count: "Số lượng tiền gửi duy nhất",
    unique_withdrawal_count: "Số lần rút tiền duy nhất",
    second_deposit_count: "Số lần gửi tiền thứ hai",
    reject_date: "Ngày từ chối",
    processing_date: "Ngày xử lý",
    deposit_withdrawal_different: "Rút tiền gửi khác nhau",
    external_id: "ID bên ngoài",
    draft_version: "Phiên bản nháp",
    prod_version: "Phiên bản sản xuất",
    purchased_date: "Ngày mua",
    completed_amount: "Số tiền đã hoàn thành",
    min_amount: "Số tiền tối thiểu",
    max_amount: "Số tiền tối đa",
    total_claimed_amount: "Tổng số tiền đã nhận",
  },
  date_ranges: {
    0: "Hôm nay",
    1: "Hôm qua",
    2: "Tháng này",
    4: "Tháng trước",
  },
  langList: {
    EN: "Tiếng Anh",
    CN: "Trung Quốc",
    PHP: "Philippines",
    esp: "Tây Ban Nha",
    RUS: "Tiếng Nga",
    VI: "Tiếng Việt",
    MS: "Tiếng Mã Lai",
    NE: "Tiếng Nepal",
    CT: "Tiếng Trung (Đài Loan)",
    BN: "Tiếng Bangla"
  },
  menulist: {
    home: "Nhà",
    hot: "Nóng",
    slot_game: "Khe cắm",
    casino: "Sòng bạc",
    sportsbook: "Sách thể thao",
    fishing: "Câu cá",
    lottery: "Xổ số",
    poker: "Poker",
    hash_game: "Trò chơi băm",
    sabong: "Sabong",
    promotion: "Khuyến mãi",
    review: "Đánh giá | Đánh giá",
    news: "Tin tức",
    live_stream: "Phát trực tiếp",
    vip: "VIP",
    referral: "Giới thiệu",
    favourite: "Yêu thích",
    mission: "Nhiệm vụ (Trò chơi nhỏ)",
    spin: "Quay",
    leaderboard: "Bảng xếp hạng",
    account: "Tài khoản",
    deposit: "Đặt cọc",
    withdrawal: "Rút tiền",
    bet_history: "Lịch sử đặt cược",
    pending_status: "Đổi mật khẩu",
    change_password: "Change Password",
    profile: "Hồ sơ",
    banking_details: "Chi tiết ngân hàng",
    inbox: "Hộp thư đến",
    voucher: "Phiếu thưởng",
    wallet: "Ví",
    statement: "Tuyên bố",
    download: "Tải về",
    game: "Trò chơi",
    special: "Đặc biệt",
    misc: "Khác",
    contact_us: "Liên hệ với chúng tôi",
    e_sportsbook: "Thể thao điện tử",
    lotto: "Xổ số",
    p2p: "P2P",
    other: "Khác",
    vip2: "VIP2",
    referral2: "Giới thiệu2",
    event: "Sự kiện",
    daily_reward: "Phần thưởng hàng ngày",
    play2earn: "Chơi 2 Kiếm tiền",
    redemption: "Cứu chuộc",
    card_board: "Bảng thẻ",
    lobby: "Sảnh",
    in_house: "Trong nhà",
    transfer: "Chuyển khoản",
    horse_racing: "Đua ngựa",
    register: "Đăng ký",
    login: "Đăng nhập",
    transaction_history: "Lịch sử giao dịch",
    bingo: "Chơi lô tử",
    member: "Thành viên",
    arcade: "Trò chơi điện tử",
    crash: "Sụp đổ",
    freeplay: "Chơi miễn phí",
    others: "Những người khác",
  },

  ok: "Được rồi",
  cancel: "Hủy",
  login: "Đăng nhập",
  logout: "Đăng xuất",
  add: "Thêm",
  edit: "Chỉnh sửa",
  delete: "Xóa",
  refresh: "Làm mới",
  action: "Hành động",
  id: "ID",
  name: "Tên",
  all: "Tất cả",
  search: "Tìm kiếm",
  remove: "Xóa",
  save: "Lưu",
  account: "Tài khoản",
  settings: "Cài đặt",
  on: "BẬT",
  off: "TẮT",
  new: "Mới",
  clear: "Rõ ràng",
  users: "Người dùng | Người dùng",
  username: "Tên người dùng",
  password: "Mật khẩu",
  created_on: "Tạo trên",
  active: "Hoạt động",
  page_size: "Kích thước trang",
  status: "Trạng thái",
  result: "Kết quả",
  close: "Đóng",
  back: "Trở lại",
  show: "Hiển thị",
  login_id: "ID đăng nhập",
  date_time: "Ngày giờ",
  ip_address: "Địa chỉ IP",
  domain_name: "Tên miền",
  browser_agent: "Tác nhân trình duyệt",
  action_by: "Hành động bởi",
  details: "Chi tiết",
  key: "Chìa khóa | Chìa khóa",
  value: "Giá trị | Giá trị",
  from: "Từ",
  to: "Đến",
  type: "Kiểu",
  criteria: "Tiêu chí",
  log: "Nhật ký",
  report: "Báo cáo",
  security_tag: "Thẻ bảo mật",
  security_code: "Mã bảo mật",
  submit: "Gửi",
  disable: "Vô hiệu hóa",
  operators: "Nhà điều hành | Người điều hành",
  members: "Các thành viên",
  account_id: "ID tài khoản",
  confirm_password: "Xác nhận mật khẩu",
  full_name: "Họ và tên",
  contact_phone: "Liên hệ điện thoại",
  contact_email: "Email liên hệ",
  dashboard: "Bảng điều khiển",
  sub_account: "Tài khoản phụ",
  authority_option: "Tùy chọn thẩm quyền",
  banks: "Ngân hàng | Ngân hàng",
  login_ip: "Đăng nhập Ip",
  block: "Khối",
  profile_id: "ID hồ sơ",
  suspend: "Tạm ngưng",
  deposit: "Nạp tiền",
  withdrawal: "Rút tiền",
  bulk_withdrawal: "Rút tiền hàng loạt",
  rejected: "Bị từ chối",
  processed: "Đã xử lý",
  pending: "Đang chờ xử lý",
  member: "Thành viên",
  amount: "Số tiền",
  bank_acc_no: "Số tài khoản ngân hàng",
  deposit_date: "Ngày gửi tiền",
  deposit_method: "Phương thức gửi tiền",
  approve: "Phê duyệt",
  reject: "Từ chối",
  remark: "Nhận xét",
  ticket_detail: "Chi tiết vé",
  promo: "Khuyến mãi",
  package: "Đóng gói",
  created_date: "Ngày tạo",
  currency: "Tiền tệ",
  bank_acc_holder: "Chủ sở hữu tài khoản ngân hàng",
  ref_no: "Tham chiếu số.",
  vip: "VIP",
  modified_date: "Ngày sửa đổi",
  modified_by: "Sửa đổi bởi",
  bank_member: "Thành viên ngân hàng",
  bank_operator: "Nhà điều hành ngân hàng",
  bank_name: "Tên ngân hàng",
  bank_acc_type: "Loại tài khoản ngân hàng",
  account_balance: "Số dư tài khoản",
  threshold: "Ngưỡng",
  incoming: "Đến",
  outgoing: "Đi ngoại",
  frequency: "Tần số",
  reset_threshold: "Đặt lại ngưỡng",
  adjust_balance: "Điều chỉnh số dư",
  bank_from: "Ngân hàng từ",
  bank_to: "Ngân hàng đến",
  attachment: "Tệp đính kèm",
  sender_bank: "Ngân hàng gửi",
  sender_bank_acc_no: "Số tài khoản ngân hàng gửi",
  sender_bank_acc_holder: "Chủ tài khoản ngân hàng gửi",
  audit: "Kiểm toán",
  action_status: "Trạng thái hành động",
  action_date: "Ngày hành động",
  promotion: "Khuyến mãi",
  promo_id: "ID khuyến mãi",
  promo_name: "Tên quảng cáo",
  package_id: "ID gói",
  claim_type: "Loại yêu cầu",
  bonus_rate: "Tỷ lệ thưởng",
  max_bonus: "Thưởng tối đa",
  rollover: "Vòng cược",
  start_date: "Ngày bắt đầu",
  end_date: "Ngày kết thúc",
  adj_amount: "Điều chỉnh số tiền",
  promotion_member: "Thành viên khuyến mãi",
  on_going: "Đang đi",
  knock_off: "Nhái",
  all_ongoing: "Tất cả đang diễn ra",
  deposit_amount: "Số tiền nạp",
  base_amount: "Số tiền gốc",
  bonus_amount: "Số tiền thưởng",
  target_amount: "Số tiền mục tiêu",
  claim_date: "Ngày yêu cầu",
  accumulate_win: "Tích lũy chiến thắng",
  accumulate_turnover: "Tích lũy doanh thu",
  bonus: "Tiền thưởng",
  bonus_log: "Nhật ký tiền thưởng",
  member_id: "ID thành viên",
  before_balance: "Trước khi cân bằng",
  transfer_amount: "Số tiền chuyển",
  after_balance: "Sau khi cân bằng",
  created_by: "Được tạo ra bởi",
  bonus_name: "Tên thưởng",
  bonus_desc: "Mô tả tiền thưởng",
  bonus_type: "Loại tiền thưởng",
  add_promo: "Thêm khuyến mãi",
  bonus_value: "Giá trị thưởng",
  attach_promo: "Đính kèm khuyến mãi",
  daily_statement: "Báo cáo hàng ngày",
  working_date: "Ngày làm việc",
  opening_balance: "Số dư mở cửa",
  turnover: "Doanh thu",
  valid_turnover: "Doanh thu hợp lệ",
  winlose: "Thua",
  withdrawal_amount: "Số tiền rút",
  closing_balance: "Số dư kết thúc",
  sub_total: "Tổng phụ",
  grand_total: "Tổng tổng",
  daily_winlose: "Thắng hàng ngày",
  game_result_slots: "Kết quả trò chơi (Slots)",
  game_result_livecasino: "Kết quả trò chơi (Livecasino)",
  game_result_rebate: "Kết quả trò chơi (Hoàn tiền)",
  game_result_sportsbook: "Kết quả trò chơi (Thể thao)",
  game_result_cockfight: "Kết quả trò chơi (chọi gà)",
  game_result_rescue: "Kết quả trò chơi (Giải cứu)",
  game_result_others: "Kết quả trò chơi (Khác)",
  bet_count: "Số lượng cược",
  result_id: "ID kết quả",
  bet_time: "Thời gian đặt cược",
  result_time: "Thời gian kết quả",
  payout: "Thanh toán",
  game_type: "Loại trò chơi",
  game_name: "Tên trò chơi",
  game_provider: "Nhà cung cấp trò chơi",
  reset: "Đặt lại",
  mode: "Chế độ",
  balance: "Cân bằng",
  min_bal_knock_off_promo: "Min Bal. (Để tự động loại bỏ quảng cáo)",
  social_account: "Tài khoản xã hội",
  wechat: "Wechat",
  telegram: "Điện tín",
  whatsapp: "Whatsapp",
  facebook: "Facebook",
  instagram: "Instagram",
  login_log: "Nhật ký đăng nhập",
  platform: "Nền tảng",
  bank_statement: "Sao kê ngân hàng",
  transfer_date: "Ngày chuyển nhượng",
  detail: "Chi tiết",
  date: "Ngày",
  transfer_list: "Danh sách chuyển nhượng",
  credit: "Tín dụng",
  badge: "Huy hiệu",
  debit: "Ghi nợ",
  month: "Tháng",
  unblock: "Bỏ chặn",
  unblock_member: "Bỏ chặn thành viên",
  unblock_operator: "Bỏ chặn nhà điều hành",
  referrer_id: "ID giới thiệu",
  referrer_code: "Mã giới thiệu",
  referral_code: "Mã giới thiệu",
  bonus_and_adjustment: "Tiền thưởng & Điều chỉnh",
  adjustment: "Điều chỉnh",
  incoming_amount_threshold: "Ngưỡng số tiền đến",
  outgoing_amount_threshold: "Ngưỡng số tiền đi",
  knock_off_by: "Knock Off By",
  knock_off_date: "Ngày nhái",
  total_turnover: "Tổng doanh thu",
  total_winlose: "Toàn bộ thua cuộc",
  total_deposit: "Tổng số tiền gửi",
  total_member: "Tổng số thành viên",
  active_player: "Người chơi đang hoạt động",
  top_winner: "Người chiến thắng hàng đầu",
  top_loser: "Người thua cuộc",
  winner: "Người chiến thắng",
  loser: "Kẻ thua cuộc",
  deposit_count: "Số lần nạp",
  withdrawal_count: "Số lần rút",
  alert: "Cảnh báo",
  incoming_threshold: "Ngưỡng nạp vào",
  incoming_frequency: "Tần suất nạp vào",
  outgoing_threshold: "Ngưỡng rút ra",
  outgoing_frequency: "Tần suất rút ra",
  reset_password: "Đặt lại mật khẩu",
  transfer: "Chuyển khoản",
  company_bank: "Ngân hàng công ty",
  company_bank_acc_no: "Số tài khoản ngân hàng công ty",
  company_bank_acc_holder: "Chủ sở hữu tài khoản ngân hàng công ty",
  registered_member: "Thành viên đã đăng ký",
  promotion_report: "Báo cáo khuyến mãi",
  deposited_member: "Thành viên đã ký gửi",
  referred_member: "Thành viên được giới thiệu",
  validated_on: "Đã xác nhận trên",
  first_deposit: "Tiền gửi đầu tiên",
  reward: "Phần thưởng",
  inbox: "Hộp thư đến",
  manual_bonus: "Tiền thưởng thủ công",
  review: "Đánh giá",
  reviews: "Đánh giá",
  review_list: "Danh sách đánh giá",
  review_detail: "Xem xét chi tiết",
  reply_review: "Phản hồi đánh giá",
  comment: "Bình luận",
  reply: "Trả lời",
  recipient_no: "Người nhận số.",
  question: "Câu hỏi",
  rating: "Đánh giá",
  content: "Nội dung",
  image: "Hình ảnh",
  monthly_rating: "Xếp hạng hàng tháng",
  affiliate: "Đặc vụ ",
  affiliate_list: "Danh sách đại lý",
  affiliate_code: "Mã đại lý",
  approved_by: "Được chấp thuận bởi",
  approved_date: "Ngày phê duyệt",
  bank_affiliate: "Đại lý ngân hàng",
  bank_id: "ID ngân hàng",
  ticket_detail_affiliate: "Đại lý chi tiết vé",
  pending_application: "Đơn đăng ký đang chờ xử lý",
  pending_review_withdrawal: "Chờ xử lý và xem xét rút tiền",
  unblock_affiliate: "Bỏ chặn đặc vụ",
  wallet_adjust: "Điều chỉnh ví",
  comm_package: "Gói Comm",
  affiliate_id: "ID đại lý",
  sub_account_detail: "Chi tiết tài khoản phụ",
  daily_winlose_affiliate: "Winlose hàng ngày (Đại lý)",
  daily_deposit_affiliate: "Tiền gửi hàng ngày (Đại lý)",
  export_excel: "Xuất Excel",
  get_tac: "Lấy OTP",
  tac_code: "Mã OTP",
  expiry_date: "Ngày hết hạn",
  inactive: "Không hoạt động",
  last_deposit_date: "Ngày gửi tiền cuối cùng",
  coupon: "Phiếu giảm giá",
  allocated: "Phân bổ",
  claimed: "Tuyên bố",
  approved: "Đã được phê duyệt",
  coupon_code: "Mã phiếu giảm giá",
  coupon_quota: "Hạn ngạch phiếu giảm giá",
  current_allocated: "Phân bổ hiện tại",
  new_allocated: "Phân bổ mới",
  update: "Cập nhật",
  copy: "Sao chép",
  bonus_rate_percent: "Tỷ lệ thưởng (%)",
  coupon_desc: "Mô tả phiếu giảm giá",
  both: "Cả hai",
  issue_free_spin: "Cấp vòng quay miễn phí",
  game: "Trò chơi",
  max_win_amount: "Số tiền thắng tối đa",
  utm_list: "Danh sách UTM",
  search_by_member: "Tìm kiếm theo thành viên",
  campaign: "Chiến dịch",
  deposited: "Đã gửi",
  search_by_id: "Tìm kiếm theo ID",
  get_bank_tac: "Lấy OTP ngân hàng",
  bank_statement_daily: "Sao kê ngân hàng (hàng ngày)",
  transfer_type: "Loại chuyển",
  audit_freebies_list: "Danh sách quà tặng miễn phí kiểm toán",
  acknowledge: "Thừa nhận",
  submit_acknowledgement: "Gửi xác nhận",
  is_ack: "Là Ack",
  yes: "Vâng",
  no: "Không",
  audit_rescue_fund_list: "Danh sách Quỹ cứu hộ kiểm toán",
  global_setting: "Cài đặt toàn cầu",
  signup_ip: "Đăng ký IP",
  last_login_ip: "IP đăng nhập cuối cùng",
  last_login_time: "Thời gian đăng nhập cuối cùng",
  link: "Liên kết",
  is_default: "là mặc định",
  is_public: "Công khai",
  bank_group: "Nhóm ngân hàng",
  set_default: "Đặt mặc định",
  group_id: "ID nhóm",
  group_name: "Tên nhóm",
  provider_maintenance: "Bảo trì nhà cung cấp",
  provider_code: "Mã nhà cung cấp",
  provider_name: "Tên nhà cung cấp",
  withdrawal_limit: "Giới hạn rút tiền",
  limit_id: "Giới hạn ID",
  limit_name: "Tên giới hạn",
  daily_amount: "Số tiền hàng ngày",
  daily_frequency: "Tần suất hàng ngày",
  promotion_id: "Mã khuyến mãi",
  promotion_name: "Tên khuyến mãi",
  withhold_bonus: "Giữ lại tiền thưởng",
  withhold_amount: "Số tiền khấu lưu",
  withhold_amt: "Giữ lại Amt",
  max_withdraw_amt: "Tối đa rút Amt",
  max_withdraw_amount: "Số tiền rút tối đa",
  monday: "Thứ hai",
  tuesday: "Thứ ba",
  wednesday: "Thứ tư",
  thursday: "Thứ năm",
  friday: "Thứ sáu",
  saturday: "Thứ bảy",
  sunday: "Chủ nhật",
  start_time: "Thời gian bắt đầu",
  end_time: "Thời gian kết thúc",
  day: "Ngày | Ngày",
  coupon_status: "Trạng thái phiếu giảm giá",
  campaign_id: "ID chiến dịch",
  campaign_name: "Tên chiến dịch",
  promotion_group: "Nhóm khuyến mãi",
  referee_list: "Danh sách trọng tài",
  account_verified: "Tài khoản đã được xác minh",
  verified_date: "Ngày xác minh",
  ticket_list: "Danh sách vé",
  vip_id: "ID VIP",
  vip_name: "Tên VIP",
  self_rebate_rate: "Tỷ lệ tự hoàn lại (%)",
  downline_rebate_rate: "Tỷ lệ chiết khấu tuyến dưới(%)",
  provider: "Nhà cung cấp",
  match_id: "ID khớp",
  home_team: "Đội nhà",
  away_team: "Đội khách",
  home_team_new: "Đội nhà mới",
  away_team_new: "Đội khách mới",
  updated_by: "Cập nhật bởi",
  updated_on: "Cập nhật",
  home_score: "Tỷ số sân nhà",
  away_score: "Tỷ số sân khách",
  home_score_new: "Điểm sân nhà mới",
  away_score_new: "Điểm sân khách mới",
  team: "Đội",
  match_time: "Thời gian thi đấu",
  match_round: "Vòng thi đấu",
  home_group: "Nhóm nhà",
  away_group: "Nhóm khách",
  match: "Trận đấu",
  match_status: "Trạng thái trận đấu",
  insert: "Chèn",
  pin: "Ghim",
  bet_list: "Danh sách cược",
  result_list: "Danh sách kết quả",
  bet_id: "ID đặt cược",
  bet_home: "Đặt cược về nhà",
  bet_away: "Đặt cược đi",
  bet_on: "Đặt cược vào",
  min_deposit: "Tiền gửi tối thiểu",
  min_withdrawal: "Rút tiền tối thiểu",
  raise_deposit_ticket: "Tạo phiếu nạp tiền",
  method: "Phương pháp",
  one_time_depositor: "Người gửi tiền một lần",
  // current_month_non_depositor: "Người không gửi tiền trong tháng hiện tại",
  current_month_non_depositor: "Người chưa nạp tháng này",
  current_month_no_login: "Tháng hiện tại không đăng nhập",
  ticket_date: "Ngày vé",
  ftd_amount: "Số tiền FTD",
  bonus_issue: "Cấp thưởng",
  promotion_summary: "Tóm tắt chương trình khuyến mãi",
  promotion_summary_detail: "Tóm tắt chương trình khuyến mãi (Chi tiết)",
  claim_frequency: "Tần suất yêu cầu",
  provider_list: "Danh sách nhà cung cấp",
  platform_winlose: "Nền tảng Winlose",
  adjustment_amount: "Số tiền điều chỉnh",
  referee_count: "Số người giới thiệu",
  category: "Thể loại'",
  update_vip: "Cập nhật VIP",
  promotion_signup: "Đăng ký khuyến mãi",
  provider_bet_limit: "Giới hạn đặt cược của nhà cung cấp",
  update_member_bet_limit: "Cập nhật giới hạn cược thành viên",
  bet_limit: "Giới hạn đặt cược",
  sports_game: "Thể thao/Trò chơi",
  league_name: "Tên Liên đoàn",
  home_team_name: "Tên đội nhà",
  away_team_name: "Tên đội khách",
  wl_status: "Tình trạng thua cuộc",
  available_bank_account: "Tài khoản ngân hàng khả dụng",
  group_bank_account: "Tài khoản ngân hàng nhóm",
  edit_bank_group: "Chỉnh sửa nhóm ngân hàng",
  edit_bank_account_group: "Chỉnh sửa nhóm tài khoản ngân hàng",
  redeposit: "Nạp lại",
  upline: "Đường lên",
  downline: "Đường dưới",
  available_promotion: "Khuyến mãi có sẵn",
  group_promotion: "Quảng bá nhóm",
  edit_promotion_group: "Chỉnh sửa nhóm khuyến mãi",
  edit_promotion_group_norm: "Quản lý khuyến mãi trong nhóm",
  balance_before: "Cân bằng trước đây",
  balance_after: "Cân bằng sau",
  signup_count: "Số lượt đăng ký",
  verified_count: "Số lượt xác minh",
  active_member: "Thành viên hoạt động",
  ftd_count: "Số lượt FTD",
  daily_summary_company: "Tóm tắt hàng ngày (Công ty)",
  daily_summary_operator: "Tóm tắt hàng ngày (Người điều hành)",
  daily_summary_member: "Tóm tắt hàng ngày (Thành viên)",
  daily_ledger_operator: "Sổ cái hàng ngày (Nhà điều hành)",
  bonus_list: "Danh sách tiền thưởng",
  ltd_date: "Ngày LTD",
  adjustment_log: "Nhật ký điều chỉnh",
  get_inbox: "Nhận hộp thư đến",
  is_claimed: "được tuyên bố",
  mix_parlay: "Mix Parlay",
  event: "Sự kiện",
  result_changes_log: "Nhật ký thay đổi kết quả",
  view_detail: "Xem chi tiết",
  total_referee: "Tổng trọng tài",
  verified_signup: "Đã xác minh / Đăng ký",
  ftd: "FTD | Tiền gửi lần đầu",
  raw_msg: "Thông điệp thô",
  unselect_all: "Bỏ chọn tất cả",
  select_all: "Chọn tất cả",
  edit_bet_limit: "Chỉnh sửa giới hạn cược",
  provider_game_off: "Trò chơi nhà cung cấp tắt",
  provider_hot_game: "Trò chơi nóng của nhà cung cấp",
  game_id: "ID trò chơi",
  game_list: "Danh sách trò chơi",
  off_list: "Danh sách tắt",
  provider_rtp: "RTP của nhà cung cấp",
  rtp: "RTP",
  signup_date: "Ngày đăng ký",
  free_credit: "Tín dụng miễn phí",
  downline_rebate: "Giảm giá tuyến dưới",
  game_rebate: "Hoàn tiền trò chơi",
  rebate: "Giảm giá",
  ftd_date: "Ngày FTD",
  provider_winlose_company: "Nhà cung cấp Winlose (Công ty)",
  // provider_winlose_operator: "Nhà cung cấp Winlose (Nhà điều hành)",
  provider_winlose_operator: "Winlose Nhà cung cấp (Điều hành)",
  already_hit: "Đã đánh",
  ongoing: "Đang diễn ra",
  members_export: "Thành viên (Xuất khẩu)",
  get_recent_deposit: "Lấy khoản nạp gần đây",
  recent_deposit: "Tiền gửi gần đây",
  survey_list: "Danh sách khảo sát",
  modified_on: "Đã sửa đổi",
  cms: "CMS",
  announcement_banner: "Biểu ngữ thông báo",
  promotion_banner: "Biểu ngữ khuyến mãi",
  slide_banner: "Biểu ngữ trượt",
  seo_page: "Trang SEO",
  en_title: "Tiêu đề (EN)",
  cn_title: "Tiêu đề (CN)",
  local_title: "Tiêu đề (ĐỊA PHƯƠNG)",
  en_img: "Hình ảnh (EN)",
  cn_img: "Hình ảnh (CN)",
  local_img: "Hình ảnh (LOCAL)",
  before_login: "Trước khi đăng nhập",
  after_login: "Sau khi đăng nhập",
  en: "EN",
  move_up: "Di chuyển",
  move_down: "Di chuyển xuống",
  banner_type: "Loại biểu ngữ",
  default_order: "Lệnh mặc định",
  item_order: "Đặt hàng mặt hàng",
  title: "Tiêu đề",
  banner_id: "ID biểu ngữ",
  order: "Trật tự",
  body: "Cơ thể",
  en_image: "Hình ảnh (EN)",
  local_image: "Hình ảnh (LOCAL)",
  move: "Di chuyển",
  en_img_desktop: "Máy tính để bàn hình ảnh (EN)",
  cn_img_desktop: "Máy tính để bàn hình ảnh (CN)",
  local_img_desktop: "Máy tính để bàn hình ảnh (LOCAL)",
  en_img_mobile: "Hình ảnh di động (EN)",
  cn_img_mobile: "Hình ảnh di động (CN)",
  local_img_mobile: "Hình ảnh di động (LOCAL)",
  login_required: "Yêu cầu đăng nhập",
  new_window_tab: "Cửa sổ / Tab mới",
  current_page: "Trang hiện tại",
  target: "Mục tiêu",
  event_filter: "Bộ lọc sự kiện",
  alt: "Thay thế",
  href: "Href",
  image_desktop: "Hình ảnh máy tính để bàn",
  image_mobile: "Hình ảnh di động",
  en_alt: "Alt (EN)",
  local_alt: "Alt (ĐỊA PHƯƠNG)",
  en_href: "Href (EN)",
  local_href: "HREF (ĐỊA PHƯƠNG)",
  en_image_desktop: "Hình ảnh máy tính để bàn (EN)",
  active_period: "Thời gian hoạt động",
  en_item: "Mục (EN)",
  local_item: "Mục (ĐỊA PHƯƠNG)",
  meta_title: "Tiêu đề Meta",
  meta_keywords: "Từ khóa Meta",
  meta_url: "URL meta",
  meta_canonical: "Meta Canonical",
  meta_author: "Tác giả Meta",
  meta_publisher: "Nhà xuất bản Meta",
  meta_lang: "Meta Lang",
  meta_desc: "Meta Desc",
  meta_image: "Hình ảnh siêu hình",
  page: "Trang",
  item: "Mục",
  remove_desktop_image: "Xóa hình ảnh máy tính để bàn",
  remove_mobile_image: "Xóa hình ảnh di động",
  page_name: "Tên trang",
  login_date: "Ngày đăng nhập",
  ftd_amount_min: "Số tiền FTD tối thiểu",
  ftd_amount_max: "Số tiền FTD tối đa",
  fl_provider_code: "Nhà cung cấp khởi chạy đầu tiên",
  fl_game_id: "ID trò chơi khởi chạy đầu tiên",
  fl_game_name: "Tên trò chơi khởi chạy đầu tiên",
  top_deposit: "Tiền gửi hàng đầu",
  top_withdrawal: "Rút tiền hàng đầu",
  top_promotion: "Khuyến mãi hàng đầu",
  outstanding_balance: "Số dư chưa thanh toán",
  last_update_time: "Thời gian cập nhật cuối cùng",
  trace: "Dấu vết",
  trace_outstanding: "Dấu vết nổi bật",
  outstanding: "Xuất sắc",
  clear_outstanding: "Xóa công nợ",
  meta_image_url: "Url siêu hình ảnh",
  member_bonus: "Tiền thưởng thành viên",
  crm_list: "Danh sách CRM",
  advance_search: "Tìm kiếm trước",
  deposit_count_from: "Số tiền gửi từ",
  deposit_count_to: "Nạp tiền",
  deposit_amount_from: "Số tiền gửi từ",
  deposit_amount_to: "Số tiền gửi đến",
  min_day_no_login: "Min. Day No Login",
  min_day_no_deposit: "Min. Day No Deposit",
  last_login: "Đăng nhập cuối cùng",
  last_deposit: "Tiền gửi cuối cùng",
  phone: "Điện thoại",
  email: "Email",
  ip_whitelist: "Danh sách trắng IP",
  ip: "IP",
  payment_option: "Tùy chọn thanh toán",
  payment_mode: "Phương thức thanh toán",
  payment_desc: "Chi tiết thanh toán",
  success: "THÀNH CÔNG",
  failed: "THẤT BẠI",
  bank_member_ewallet: "Thành viên ngân hàng (Ví điện tử)",
  processing: "Chế biến",
  recipient_bank_id: "Mã ngân hàng nhận",
  recipient_bank_acc_no: "Số tài khoản ngân hàng nhận",
  ticket_auto_withdrawal_log: "Nhật ký vé (Tự động rút tiền)",
  resubmit_ticket: "Gửi lại vé",
  ticket_export: "Vé (Xuất khẩu)",
  export_deposit: "Xuất khẩu (Tiền gửi)",
  export_deposit_all: "Xuất tất cả (tiền gửi)",
  export_withdrawal: "Xuất khẩu (rút tiền)",
  export_withdrawal_all: "Xuất tất cả (rút tiền)",
  export_member_all: "Xuất tất cả (thành viên)",
  processed_rejected: "Đã xử lý (Bị từ chối)",
  channel: "Kênh",
  influencer: "Người có ảnh hưởng",
  ticket_id: "ID vé",
  recommend: "Đề xuất",
  sequence: "Trình tự",
  statement_info: "Thông tin tuyên bố",
  slots: "Máy đánh bạc",
  livecasino: "Sòng bạc trực tiếp",
  sportsbook: "Thể thao",
  cockfight: "Chọi gà",
  member_list: "Danh sách thành viên",
  operator: "Người điều hành",
  game_balance: "Cân bằng trò chơi",
  claim_limit: "Giới hạn yêu cầu",
  max_withdraw_multiple: "Rút tiền tối đa bội",
  payment_gateway: "Cổng thanh toán",
  min_limit: "Giới hạn tối thiểu",
  max_limit: "Giới hạn tối đa",
  total: "Tổng",
  rebate_summary: "Tóm tắt chiết khấu",
  rebate_summary_daily: "Tóm tắt giảm giá hàng ngày",
  rebate_member: "Thành viên giảm giá",
  self: "Bản thân",
  system_balance: "Cân bằng hệ thống",
  rejected_onload: "Bị từ chối (Đang tải)",
  no_bonus: "Không có tiền thưởng",
  audit_ticket: "Phiếu kiểm toán",
  review_ticket: "Phiếu đánh giá",
  edit_promotion_group_norm_seq: "Quản lý thứ tự khuyến mãi trong nhóm",
  signup_bonus: "Tiền thưởng đăng ký",
  settlement_type: "Loại hình giải quyết",
  carry_over: "Carry Over",
  comm_sports: "Ủy ban (Thể thao)",
  comm_slots: "Hoa hồng (Slots)",
  comm_livecasino: "Hoa hồng (Livecasino)",
  comm_cockfight: "Ủy ban (Chọi gà)",
  comm_others: "Hoa hồng (Khác)",
  update_comm: "Cập nhật hoa hồng",
  update_carry_over: "Cập nhật chuyển số dư",
  ewallet: "Ví điện tử",
  withdrawal_list: "Danh sách rút tiền",
  audit_withdrawal: "Rút tiền kiểm toán",
  daily_withdrawal: "Rút tiền hàng ngày",
  adjustment_log_affiliate: "Nhật ký điều chỉnh",
  daily_statement_affiliate: "Báo cáo hàng ngày (Đại lý)",
  earning: "Kiếm tiền",
  pnl: "P & L",
  review_affiliate_ticket: "Xem xét phiếu tiếp thị liên kết",
  audit_affiliate_ticket: "Kiểm toán phiếu tiếp thị liên kết",
  turnover_downline: "Doanh thu (Downline)",
  valid_turnover_downline: "Doanh thu hợp lệ (Downline)",
  winlose_downline: "WinLose (Đường dưới)",
  bet_count_downline: "Số lượng cược (Downline)",
  turnover_member: "Doanh thu (thành viên)",
  valid_turnover_member: "Doanh thu hợp lệ (Thành viên)",
  winlose_member: "WinLose (Thành viên)",
  bet_count_member: "Số lượng cược (thành viên)",
  dashboard_affiliate: "Bảng điều khiển (Đại lý)",
  total_agent: "Tổng đại lý",
  top_turnover: "Doanh thu hàng đầu",
  bonus_count: "Số tiền thưởng",
  deposit_amount_downline: "Số tiền nạp (Downline)",
  deposit_count_downline: "Số lượng tiền gửi (Downline)",
  bonus_amount_downline: "Số tiền thưởng (Downline)",
  bonus_count_downline: "Số tiền thưởng (Downline)",
  deposit_amount_member: "Số tiền gửi (Thành viên)",
  deposit_count_member: "Số lượng tiền gửi (Thành viên)",
  bonus_amount_member: "Số tiền thưởng (Thành viên)",
  bonus_count_member: "Số tiền thưởng (Thành viên)",
  verified: "Đã xác minh",
  round_id: "ID tròn",
  unfinish_round: "Vòng chưa hoàn thành",
  smartico_bonus_report: "Báo cáo tiền thưởng Smartico",
  unclaimed_amount: "Số tiền chưa được nhận",
  claimed_amount: "Số tiền yêu cầu",
  unclaimed_count: "Bá tước không có người nhận",
  claimed_count: "Số lượng tuyên bố",
  submit_time: "Ngày tạo",
  deposit_time: "Ngày sửa đổi",
  funds_list: "Danh sách vé",
  fund_transfer_provider: "Nhà cung cấp chuyển khoản quỹ",
  daifu_list_auto_withdrawal: "Danh sách vé (Tự động rút tiền)",
  btn_href: "Nút Href",
  btn_text: "Văn bản nút",
  recent_inbox_claim: "Khiếu nại hộp thư đến gần đây",
  raise_deposit_ticket_gateway: "Tạo phiếu nạp tiền (Cổng thanh toán)",
  gateway_acc: "Tài khoản Gateway",
  provider_winlose_member: "Nhà cung cấp Winlose (Thành viên)",
  review_by: "Đánh giá bởi",
  daifu_list_auto_withdrawal_export: "Xuất vé (Tự động rút tiền)",
  retention: "Retenton",
  current_month_active_user: "Người dùng đang hoạt động trong tháng hiện tại",
  current_month_active: "Tháng hiện tại đang hoạt động",
  first_month: "Tháng đầu tiên",
  fmwinlose: "FMWinlose",
  fmdeposit_amount: "Số tiền FMDeposit",
  cohort: "Nhóm",
  promotion_withdrawal_summary: "Tóm tắt rút tiền khuyến mãi",
  promotion_withdrawal_summary_detail: "Tóm tắt rút tiền khuyến mãi (Chi tiết)",
  unique_player: "Người chơi duy nhất",
  year: "Năm | Năm",
  audit_time_modified: "Ngày sửa đổi",
  audit_time_created: "Ngày tạo",
  approve_time: "Ngày sửa đổi",
  unique_login_count: "Số lần đăng nhập duy nhất",
  unique_deposit_count: "Số lần nạp duy nhất",
  unique_withdrawal_count: "Số lần rút duy nhất",
  second_deposit_count: "Số lần nạp thứ hai",
  unique_login: "Đăng nhập duy nhất",
  unique_withdrawal: "Rút tiền duy nhất",
  second_deposit: "Tiền gửi thứ hai",
  deposit_withdrawal_different: "Chênh lệch Nạp/Rút",
  ngr: "NGR",
  audit_list: "Danh sách kiểm toán",
  rollback_count: "Số lần khôi phục",
  rejected_ticket_id: "ID vé bị từ chối",
  rollback: "Khôi phục",
  recipient_bank_acc_holder: "Chủ tài khoản ngân hàng nhận",
  reject_date: "Ngày từ chối",
  processing_date: "Ngày xử lý",
  manual_approve: "Phê duyệt (Hướng dẫn sử dụng)",
  pending_review_funds: "Pending & Review Ticket",
  table_id: "ID bảng",
  member_label: "Nhãn thành viên",
  label_name: "Tên nhãn",
  label: "Nhãn",
  available_label: "Nhãn có sẵn",
  iframe: "Iframe",
  iframe_url: "URL Iframe",
  exchange_rate: "Tỷ giá hối đoái",
  rate: "Tỷ lệ",
  rate_php: "Đánh giá PHP",
  ticket_withdrawal_rollback: "Khôi phục rút vé",
  smartico_bonus_report_expired: "Báo cáo tiền thưởng Smartico (Đã hết hạn)",
  reward_type: "Loại phần thưởng",
  turnover_rebate: "Hoàn tiền doanh thu",
  turnover_rebate_1: "Hạng VIP",
  turnover_rebate_2: "Cấp doanh thu",
  vip_cycle_day: "Ngày chu kỳ VIP",
  is_addon: "Là Addon",
  no_reward: "Không có phần thưởng",
  cash: "Tiền mặt",
  cs: "Dịch vụ khách hàng",
  social_platform: "Nền tảng xã hội",
  edit_vip: "Chỉnh sửa VIP",
  edit_vip_provider: "Chỉnh sửa nhà cung cấp VIP",
  turnover_tier: "Cấp doanh thu",
  rebate_rate: "Tỷ lệ chiết khấu",
  edit_turnover_tier: "Chỉnh sửa cấp doanh thu",
  delete_turnover_tier: "Xóa Bậc Doanh thu",
  vip_log: "Nhật ký VIP",
  member_full_record: "Hồ sơ đầy đủ của thành viên",
  before: "Trước",
  after: "Sau",
  maintain: "Duy trì",
  actual_rebate: "Giảm giá thực tế",
  rounded_rebate: "Hoàn tiền làm tròn",
  rebate_mode: "Chế độ giảm giá",
  inbox_id: "ID hộp thư đến",
  rebate_type: "Loại chiết khấu",
  promotion_type: "Loại khuyến mãi",
  bonus_rate_1: "Tỷ lệ 1(%)",
  bonus_rate_2: "Tỷ lệ 2(%)",
  bonus_rate_3: "Tỷ lệ 3(%)",
  bonus_rate_4: "Tỷ lệ 4(%)",
  bonus_rate_5: "Tỷ lệ 5(%)",
  bonus_rate_6: "Tỷ lệ 6(%)",
  bonus_rate_7: "Tỷ lệ 7(%)",
  bonus_rate_8: "Tỷ lệ 8(%)",
  bonus_rate_9: "Tỷ lệ 9(%)",
  bonus_rate_10: "Tỷ lệ 10(%)",
  delete_all: "Xóa tất cả",
  rescue_fund: "Quỹ cứu hộ",
  up: "Lên",
  down: "Xuống",
  rate_percent: "Tỷ lệ %",
  cycle: "Chu kỳ",
  actual_amount: "Số tiền thực tế",
  rounded_amount: "Số tiền làm tròn",
  rescue_id: "ID cứu hộ",
  rescue_name: "Tên giải cứu",
  min_lose: "Min Thua",
  max_payout: "Thanh toán tối đa",
  payout_method: "Phương thức thanh toán",
  target_group: "Nhóm mục tiêu",
  member_vip_id: "ID VIP thành viên",
  daily: "Hàng ngày",
  weekly: "Hàng tuần",
  monthly: "Hàng tháng",
  edit_batch: "Chỉnh sửa lô",
  current_level: "Cấp độ hiện tại",
  next_level: "Cấp độ tiếp theo",
  bet_value: "Giá trị đặt cược",
  line_bet: "Đặt cược dòng",
  total_round: "Tổng vòng",
  audit_by: "Kiểm toán bởi",
  possible_next_level: "Cấp độ tiếp theo có thể",
  maintain_deposit: "Duy trì tiền gửi",
  maintain_turnover: "Duy trì doanh thu",
  starting_deposit: "Tiền gửi bắt đầu",
  starting_turnover: "Doanh thu bắt đầu",
  cycle_deposit: "Đặt cọc theo chu kỳ",
  cycle_turnover: "Vòng quay chu kỳ",
  vip_list: "Danh sách VIP",
  up_maintain: "Duy trì",
  down_lowest: "Xuống thấp nhất",
  manual: "Hướng dẫn sử dụng",
  daily_winlose_game: "Thắng hàng ngày (Trò chơi)",
  actionaff: "Hành động (Đặc vụ)",
  onload: "tải",
  update_status: "Cập nhật trạng thái",
  role_settings: "Cài đặt vai trò",
  customer_services: "Dịch vụ khách hàng",
  marketing: "Tiếp thị",
  finance: "Tài chính",
  payment: "Thanh toán",
  risk_management: "Quản lý rủi ro",
  pt: "PT",
  wallet_history: "Lịch sử ví",
  ticket_amount: "Số lượng vé",
  ignore_risk: "Bỏ qua rủi ro",
  permitted_amount: "Số tiền cho phép",
  all_pending_ticket: "Tất cả các vé đang chờ xử lý",
  rescue_fund_summary: "Tóm tắt quỹ cứu hộ",
  rescue_fund_summary_daily: "Tóm tắt Quỹ cứu hộ hàng ngày",
  rescue_fund_member: "Thành viên Quỹ cứu hộ",
  master: "Sư phụ",
  account_type: "Loại tài khoản",
  freeze: "Đóng băng",
  domain_member_setup: "Thiết lập tên miền trang web thành viên",
  domain: "Tên miền",
  domain_list: "Danh sách miền",
  domain_application: "Ứng dụng miền",
  domain_status: "Trạng thái miền",
  domain_group: "Nhóm miền",
  operator_id: "ID nhà điều hành",
  domain_type: "Loại miền",
  module: "Mô-đun",
  template: "Bản mẫu",
  custom: "Tùy chỉnh",
  default: "Mặc định",
  payment_provider: "Nhà cung cấp dịch vụ thanh toán",
  payment: "Thanh toán",
  deactivate: "Không hoạt động",
  name_server: "Máy chủ tên",
  server_account: "Tài khoản máy chủ",
  service_provider: "Nhà cung cấp dịch vụ",
  process: "Quy trình",
  provider_operator: "Nhà điều hành nhà cung cấp",
  bet_limit_member: "@:ui.bet_limit (@:ui.member)",
  global: "Cài đặt chung",
  second_id: "ID thứ hai",
  unverified: "Chưa được xác minh",
  pt_affiliate: "Phí nền tảng đại lý (%)",
  recipient_bank: "Ngân hàng nhận",
  deposit_type: "Loại tiền gửi",
  security_fund: "Quỹ bảo đảm",
  adjust_balance_op: "Ví Operator Adjust",
  adjust_security_deposit_op: "Quỹ bảo đảm nhà điều hành",
  marquee: "Marquee",
  marquee_content: "Nội dung Marquee",
  edit_marquee: "Chỉnh sửa Marquee",
  domain_available: "Tên miền có sẵn",
  daily_withdrawal_frequency: "Tần suất rút tiền hàng ngày",
  maintenance: "Bảo trì",
  max_withdrawal: "Rút tiền tối đa",
  min_balance: "Số dư tối thiểu",
  affiliate_report: "Báo cáo đại lý",
  cash_balance: "Số dư tiền mặt",
  copy_success: "Sao chép thành công!",
  copy_failed: "Sao chép không thành công!",
  your_website: "Trang web của bạn",
  correction_promo: "Thêm Khuyến mãi",
  others: "Những người khác",
  audit_log: "Nhật ký kiểm toán",
  view: "Xem",
  price: "Giá",
  package_level: "Cấp độ gói",
  bo_right: "BO đúng",
  english: "Tiếng Anh",
  simplified_chinese: "Trung Quốc (CN)",
  traditional_chinese: "Tiếng Trung (TW)",
  philippine: "Philippines",
  thai: "Tiếng Thái",
  vietnamese: "Tiếng Việt",
  indonesian: "Tiếng Indonesia",
  myanmar: "Myanmar",
  japanese: "Nhật Bản",
  korean: "Hàn Quốc",
  package_type: "Loại gói",
  full_back_office_access_right: "Quyền truy cập toàn bộ văn phòng",
  read_only_back_office: "Văn phòng hỗ trợ chỉ đọc",
  language: "Ngôn ngữ",
  lang_code: "Mã ngôn ngữ",
  description: "Mô tả",
  provider_type: "Loại nhà cung cấp",
  logo: "Logo",
  theme_provider: "Nhà cung cấp chủ đề",
  theme_content: "Nội dung chủ đề",
  content_id: "Content ID",
  content_desc: "Mô tả nội dung",
  theme_content_position: "Vị trí nội dung chủ đề",
  theme: "Chủ đề",
  theme_code: "Mã chủ đề",
  theme_name: "Tên chủ đề",
  color: "Màu sắc",
  position: "Vị trí",
  site_name: "Tên trang web",
  theme_color: "Màu chủ đề",
  theme_purchased: "Chủ đề đã mua",
  total_purchased: "Tổng số đã mua",
  purchased_date: "Ngày mua",
  purchase: "Mua hàng",
  total_site: "Tổng số trang web",
  content_setup: "Thiết lập nội dung",
  site_list: "Danh sách trang web",
  site_id: "ID trang web",
  draft_version: "Phiên bản nháp",
  prod_version: "Phiên bản sản xuất",
  production_version: "Phiên bản sản xuất",
  info: "Thông tin",
  setting: "Cài đặt",
  site_info: "Thông tin trang web",
  menu: "Thực đơn",
  game_menu: "Menu trò chơi",
  special_menu: "Thực đơn đặc biệt",
  setting_menu: "Menu cài đặt",
  error: "Lỗi",
  sync_all: "Đồng bộ hóa tất cả",
  theme_content_group: "Nhóm nội dung chủ đề",
  content_group: "Nhóm nội dung",
  content_group_desc: "Mô tả nhóm nội dung",
  parent_content_id: "ID nội dung dành cho cha mẹ",
  bo_default_domain: "Tên miền mặc định BO",
  domain_id: "ID miền",
  deactive: "Bất động",
  site_sync: "Đồng bộ hóa trang web",
  upload: "Tải lên",
  comingSoon: "Sắp ra mắt",
  profile_setting: "Profile Cài đặt",
  bank: "Ngân hàng",
  company: "Công ty",
  own: "SỞ HỮU",
  operator_setting: "Cài đặt người vận hành",
  external_id: "ID bên ngoài",
  ticket: "Vé",
  bank_owner: "Chủ ngân hàng",
  exchanged_currency: "Tiền tệ trao đổi",
  company_bank_owner: "Chủ ngân hàng công ty",
  ticket_list_member: "Danh sách vé (Thành viên)",
  game_name_exclude: "Loại trừ tên trò chơi",
  tab: "Tab",
  about_us: "Về chúng tôi",
  privacy_policy: "Chính sách bảo mật",
  responsible_gaming: "Chơi game có trách nhiệm",
  banking: "Ngân hàng",
  faqs: "Câu hỏi thường gặp",
  advertisement: "Quảng cáo",
  px_pixel_id: "ID pixel PX",
  px_token: "Mã thông báo PX",
  af_dev_key: "Phím Af Dev",
  af_apps_id: "ID ứng dụng Af",
  pp_tid: "PP TID",
  pp_pid: "PP PID",
  pp_aid: "VIỆN TRỢ PP",
  gtm_id: "Mã GTM",
  service_provider_url: "URL của nhà cung cấp dịch vụ",
  script_inject: "Chèn tập lệnh",
  head_script: "Kịch bản chính",
  body_script: "Kịch bản cơ thể",
  ads_id: "ID quảng cáo",
  member_detail: "Chi tiết thành viên",
  memberreport: "Báo cáo thành viên",
  member_log: "Nhật ký thành viên",
  general: "Tướng quân",
  top_theme: "Chủ đề hàng đầu",
  hot_game: "Trò chơi nóng",
  hot_list: "Danh sách nóng",
  new_game: "Trò chơi mới",
  popular_game: "Trò chơi phổ biến",
  featured_game: "Trò chơi nổi bật",
  new_list: "Danh sách mới",
  popular_list: "Danh sách phổ biến",
  featured_list: "Danh sách nổi bật",
  provider_new_game: "Nhà cung cấp trò chơi mới",
  provider_popular_game: "Trò chơi phổ biến của nhà cung cấp",
  provider_featured_game: "Trò chơi nổi bật của nhà cung cấp",
  website: "Trang mạng",
  site_customization: "Tùy chỉnh trang web",
  export_all: "Xuất tất cả",
  export_one: "Xuất (Trang hiện tại)",
  daily_ledger: "Sổ cái hàng ngày",
  daily_ledger_member: "Sổ cái hàng ngày (Thành viên)",
  promotion_signup_unused: "Khuyến mãi đăng ký chưa sử dụng",
  promotion_signup_ongoing: "Khuyến mãi đăng ký đang diễn ra",
  promotion_signup_winlose: "Đăng ký khuyến mãi Winlose",
  promotion_signup_winlose_operator: "Khuyến mãi đăng ký Winlose (Nhà điều hành)",
  promotion_signup_winlose_member: "Khuyến mãi đăng ký Winlose (Thành viên)",
  total_player_balance: "Tổng số dư người chơi",
  search_all: "Tìm kiếm tất cả",
  mbsetting: "Cài đặt",
  todays_highlights: "Điểm nổi bật hôm nay",
  deposit_player: "Người chơi gửi tiền",
  withdrawal_player: "Người chơi rút tiền",
  kill_rate: "Tỷ lệ tiêu diệt",
  login_player: "Người chơi đăng nhập",
  operation_management: "Hoạt động",
  game_management: "Trò chơi",
  member_management: "Thành viên",
  affiliate_management: "Đặc vụ ",
  promotion_management: "Khuyến mãi",
  mbcampaign: "Chiến dịch",
  promo_allday: "Cả ngày",
  promo_daily: "Hàng ngày",
  promo_daily_first_deposit: "Tiền gửi đầu tiên hàng ngày",
  promo_deposit_monthly: "Số lượng tiền gửi hàng tháng",
  promo_deposit_signup: "Đăng ký số tiền gửi",
  promo_deposit_weekly: "Số lượng tiền gửi hàng tuần",
  promo_newbie: "Người mới",
  promo_once: "Một lần",
  dd_review: "Đánh giá",
  game_provider_management: "Nhà cung cấp",
  exchanged_amount: "Số tiền trao đổi",
  operator_summary: "Tóm tắt nhà điều hành",
  business_id: "ID doanh nghiệp",
  game_name_exclude_log: "Nhật ký loại trừ tên trò chơi",
  cn: "CN",
  local: "ĐỊA PHƯƠNG",
  taken: "Lấy đi",
  receiver_bank: "Ngân hàng người nhận",
  receiver_bank_acc_no: "Số tài khoản ngân hàng người nhận",
  receiver_bank_acc_holder: "Người nhận tài khoản ngân hàng",
  add_balance: "Thêm số dư",
  deduct_balance: "Khấu trừ số dư",
  sync_site_content: "Đồng bộ hóa nội dung trang web",
  payment_setting: "Cài đặt thanh toán",
  payment_own: "SỞ HỮU",
  payment_global: "TOÀN CẦU",
  livechat: "Trò chuyện trực tiếp",
  chat_id: "Khóa cấp phép LiveChat",
  chat_provider: "Nhà cung cấp LiveChat",
  auto_cycle: "CHU KỲ",
  auto_all: "TẤT CẢ",
  completed_amount: "Số tiền hoàn tất",
  website_launched: "Ra mắt trang web",
  total_operators: "Tổng số nhà khai thác",
  today_active: "Hôm nay hoạt động",
  new_player_verified_signup: "Người chơi mới xác minh/ĐK",
  total_players: "Tổng số người chơi",
  depo_withdrawal_diff: "DEPO-VỚI sự khác biệt",
  claim_count: "Số lượng yêu cầu",
  ggr: "GGR",
  member_balance: "Số dư thành viên",
  players: "Người chơi",
  provider_pt: "Nhà cung cấp PT",
  base: "Căn cứ",
  topup_id: "ID nạp tiền",
  credential: "Chứng chỉ",
  credential_1: "Chứng chỉ 1",
  credential_2: "Chứng chỉ 2",
  credential_3: "Chứng chỉ 3",
  credential_4: "Chứng chỉ 4",
  credential_5: "Chứng chỉ 5",
  credential_6: "Chứng chỉ 6",
  credential_7: "Chứng chỉ 7",
  credential_8: "Chứng chỉ 8",
  credential_9: "Chứng chỉ 9",
  credential_10: "Chứng chỉ 10",
  limit: "Giới hạn",
  create: "Sáng tạo",
  hint: "Gợi ý",
  quickSetup: "Cài đặt nhanh",
  next: "Tiếp theo",
  setUpTheme: "Chủ đề thiết lập",
  checkOut: "Trả phòng",
  standardPackage: "Gói tiêu chuẩn",
  siteName: "Tên trang web",
  information: "Thông tin",
  useThisTemplate: "Sử dụng bản mẫu này",
  summary: "Tóm tắt",
  createOperatorAccount: "Tạo tài khoản nhà điều hành",
  operatorId: "ID nhà điều hành",
  operatorPwd: "Người điều hành Passsword",
  new_website: "Trang web mới",
  operator_information: "Thông tin nhà điều hành",
  bo_link: "Liên kết BO",
  daily_summary_sms: "SMS tóm tắt hàng ngày",
  daily_summary_sms_operator: "Nhà điều hành SMS tóm tắt hàng ngày",
  daily_summary_sms_operator_detail: "Chi tiết nhà điều hành SMS tóm tắt hàng ngày",
  sms_count: "Số lượng SMS",
  // provider_winlose_operator_pt: "Nhà cung cấp Winlose (Nhà điều hành PT)",
  provider_winlose_operator_pt: "Winlose Nhà C/P (Điều hành PT)",
  pt_on: "PT Bật",
  share_operator: "Nhà điều hành chia sẻ",
  share_company: "Công ty cổ phần",
  token_log: "Nhật ký token",
  template_code: "Mã mẫu",
  template_name: "Tên mẫu",
  mini_game: "Trò chơi nhỏ",
  max_game_reward: "Tối đa Phần thưởng trò chơi",
  max_chance_per_day: "Tối đa Cơ hội mỗi ngày",
  is_recurring_chance: "Lặp lại",
  token_request: "Mã thông báo",
  enabled: "Đã bật",
  disabled: "Bị vô hiệu hóa",
  unlimited: "Không giới hạn",
  max_chance_unlimited: "Tối đa Cơ hội mỗi ngày không giới hạn",
  mini_game_template: "Mẫu trò chơi nhỏ",
  reward_code: "Mã phần thưởng",
  reward_name: "Tên phần thưởng",
  reward_description: "Mô tả phần thưởng",
  reward_probability: "Xác suất phần thưởng",
  total_game: "Tổng trò chơi",
  total_played_mini_game: "Tổng số trò chơi nhỏ đã chơi",
  total_played_mini_game_detail: "Tổng số trò chơi nhỏ đã chơi chi tiết",
  total_played_mini_game_detail_operator: "Tổng số trò chơi nhỏ đã chơi chi tiết (nhà điều hành)",
  daily_pnl_operator: "P&L hàng ngày (Người điều hành)",
  token: "Mã thông báo",
  token_1: "Mã thông báo 1",
  token_2: "Mã thông báo 2",
  token_3: "Mã thông báo 3",
  token_4: "Mã thông báo 4",
  token_5: "Mã thông báo 5",
  token_6: "Mã thông báo 6",
  token_7: "Mã thông báo 7",
  cash_1: "Tiền mặt 1",
  cash_2: "Tiền mặt 2",
  cash_3: "Tiền mặt 3",
  cash_4: "Tiền mặt 4",
  cash_5: "Tiền mặt 5",
  cash_6: "Tiền mặt 6",
  cash_7: "Tiền mặt 7",
  daily_login: "Đăng ký hàng ngày (Đăng nhập hàng ngày)",
  daily_login_update: "Cập nhật Đăng ký hàng ngày (Đăng nhập hàng ngày)",
  game_result_reward: "Kết quả trò chơi (Phần thưởng)",
  current_streak: "Chuỗi hiện tại",
  login_streak: "Chuỗi đăng nhập",
  total_token: "Tổng mã thông báo",
  // total_mini_game_token_used: "Tổng số mã thông báo trò chơi nhỏ đã sử dụng",
  total_mini_game_token_used: "Tổng token mini game đã dùng",
  total_mini_game_token_used_detail: "Tổng số mã thông báo mini game đã sử dụng chi tiết",
  total_mini_game_token_used_detail_operator: "Tổng số mã thông báo trò chơi nhỏ được sử dụng chi tiết (nhà điều hành)",
  total_reward: "Tổng phần thưởng",
  total_mini_game_reward: "Tổng phần thưởng mini game",
  total_mini_game_reward_detail: "Chi tiết phần thưởng tổng mini game",
  total_mini_game_reward_detail_operator: "Tổng chi tiết phần thưởng Mini Game (Nhà điều hành)",
  token_balance: "Số dư token",
  free_game_token: "Mã thông báo trò chơi miễn phí",
  bo_url: "URL văn phòng",
  copied: "Đã sao chép",
  callback: "Gọi lại",
  api: "API",
  prefix: "Tiền tố",
  delimiter: "Dấu phân cách",
  url_callback_deposit: "URL gọi lại tiền gửi",
  url_callback_withdrawal: "URL gọi lại rút tiền",
  url_callback_affiliate: "URL gọi lại tổng đài viên",
  url_api_deposit: "URL gọi lại nạp tiền (API)",
  url_api_withdrawal: "URL gọi lại rút tiền (API)",
  url_api_balance: "URL gọi lại số dư (API)",
  prefix_deposit: "Tiền tố tiền gửi",
  prefix_withdrawal: "Tiền tố rút tiền",
  prefix_affiliate: "Tiền tố đại lý",
  prefix_delimiter: "Tiền tố dấu phân cách",
  merchant: "Thương gia",
  app_id: "ID ứng dụng",
  secret_key: "Chìa khóa bí mật",
  deposit_secret_key: "Khóa bí mật gửi tiền",
  withdrawal_secret_key: "Khóa bí mật rút tiền",
  partners: "Đối tác",
  partner_name: "Tên đối tác",
  win: "Chiến thắng",
  manifest: "Biểu hiện",
  crop: "Cây trồng",
  cropImage: "Cắt hình ảnh",
  api_url: "URL API",
  start_date_time: "Thời gian ngày bắt đầu",
  end_date_time: "Thời gian ngày kết thúc",
  authentication_key: "Khóa xác thực",
  one_week: "1 tuần",
  two_week: "2 tuần",
  one_month: "1 tháng",
  two_month: "2 tháng",
  six_month: "6 tháng",
  edit_promotion_end_date: "Chỉnh sửa ngày kết thúc chương trình khuyến mãi",
  android_app_link: "Liên kết ứng dụng Android",
  add_android_app_link: "Thêm liên kết ứng dụng Android",
  operator_details: "Chi tiết nhà điều hành",
  bsb: "BSB",
  payid: "ID thanh toán",
  cuit: "CUIT",
  merchant_key: "Chìa khóa thương gia",
  aes_key: "Khóa AES",
  paycode: "Mã thanh toán",
  api_key: "Khóa API",
  referral: "Thưởng Giới Thiệu",
  minimum_deposit: "Tiền gửi tối thiểu",
  minimum_withdrawal: "Rút tiền tối thiểu",
  maximum_withdrawal: "Rút tiền tối đa",
  cpi: "CPI",
  cpi_enrol: "Đăng ký CPI",
  interested: "Quan tâm",
  non_pickup: "Chưa nhận",
  invalid: "Không hợp lệ",
  cpi_member_list: "Danh sách thành viên CPI",
  leaderboard: "Bảng xếp hạng",
  capacity: "Sức chứa",
  reward_count: "Số phần thưởng",
  is_settled: "Đã thanh toán",
  settlement_date: "Ngày thanh toán",
  prize: "Giải thưởng",
  count: "Số lượng",
  multiplier: "Hệ số nhân",
  ranking: "Xếp hạng",
  leaderboard_ranking: "Xếp hạng bảng xếp hạng",
  joined_date: "Ngày tham gia",
  ready: "Sẵn sàng",
  busy: "Bận",
  phone_list: "Danh sách điện thoại",
  single: "Đơn lẻ",
  batch: "Theo lô",
  cpi_operator_phone_list: "Danh sách điện thoại của nhà mạng CPI",
  selected: "Đã chọn",
  call: "Gọi",
  private_key: "Khóa Riêng",
  public_key: "Khóa Công Khai",
  multi_call: "Cuộc gọi nhiều lần",
  add_custom: "Thêm tùy chỉnh",
  custom_list: "Danh sách tùy chỉnh",
  assignee: "Người được giao",
  urgency: "Mức độ khẩn cấp",
  urgency_1: "Thấp",
  urgency_2: "Trung bình",
  urgency_3: "Cao",
  edit_custom: "Chỉnh sửa tùy chỉnh",
  cpi_custom_list: "Danh sách tùy chỉnh CPI",
  free_coin_signup: "Điểm miễn phí (Đăng ký)",
  free_coin_daily: "Điểm miễn phí (Hàng ngày)",
  free_coin_min_withdrawal: "Rút tối thiểu (Điểm miễn phí)",
  free_coin_per_unit: "Tỷ lệ quy đổi điểm miễn phí (Điểm = {currency} 1)",
  adjust_free_balance: "Điều chỉnh số dư miễn phí",
  adjust_free_balance_log: "Nhật ký Số dư Miễn phí",
  signup: "Đăng ký",
  adjust: "Điều chỉnh",
  ai_assistant: "Trợ lý AI",
  en_name: "Tên (EN)",
  cn_name: "Tên (CN)",
  local_name: "Tên (ĐỊA PHƯƠNG)",
  img_small: "Hình ảnh (Nhỏ)",
  img_large: "Hình ảnh (Lớn)",
  small_image: "Hình nhỏ",
  large_image: "Hình lớn",
  forgot_password: "Quên mật khẩu",
  update_password: "Cập nhật mật khẩu",
  contact: "Liên hệ",
  keyss: "Chìa khóa",
  iv: "IV",
  callback_public_key: "Khóa Công Khai Callback",
  free_game: "Trò chơi miễn phí",
  version_no: "Số Phiên Bản",
  client_id: "ID Khách Hàng",
  symmetric_key: "Khóa Đối Xứng",
  deposit_token: "Mã Gửi Tiền",
  withdrawal_token: "Mã Rút Tiền",
  tac_bank: "Mã OTP (Ngân hàng)",
  tac_login: "Mã OTP (Đăng nhập)",
  tac_signup: "Mã OTP (Đăng ký)",
  tac_signup_aff: "Mã OTP (Đăng ký Đại lý)",
  merchant_name: "Tên Thương Gia",
  tele_status: "Trạng thái Tele",
  follow_up: "Theo dõi",
  call_type: "Loại cuộc gọi",
  on_call_list: "Trong danh sách cuộc gọi",
  inbox_valid_day: "Ngày hợp lệ của hộp thư đến",
  manual_deposit: "Nạp Thủ Công",
  withdrawal_result: "Kết quả rút tiền",
  widget_id: "Mã Widget",
  property_id: "Mã Thuộc Tính",
  referee: "Thưởng Người Được Giới Thiệu",
  game_result_free_slots: "Kết Quả Trò Chơi (Slots Miễn Phí)",
  crypto_address: "Địa Chỉ Crypto",
  crypto_network: "Mạng Crypto",
  crypto: "CRYPTO",
  exchange_currency: "Tiền Tệ Quy Đổi",
  base_rate: "Tỷ Giá Cơ Bản",
  white_label: "White Label",
  aggregator: "Nhà tổng hợp",
  deposit_rate: "Tỷ lệ Nạp",
  withdrawal_rate: "Tỷ lệ Rút",
  pending_bet_list_wbet: "Danh sách cược chờ xử lý (WBET)",
  bet_amount: "Số tiền cược",
  actual_bet_amount: "Số tiền cược thực tế",
  pending_bet_list_others: "Danh sách cược chờ xử lý (Nhà cái Thể thao khác)",
  dob: "Ngày sinh",
  mail_address: "Địa chỉ thư tín",
  crypto_withdrawal: "Rút tiền Crypto",
  institute_bank_code: "Mã Ngân Hàng Tổ Chức",
  pending_bet_list_9w: "Danh sách cược chờ xử lý (9W)",
  linkage: "Liên kết",
  linkage_op: "Toán tử liên kết",
  member_linkage: "Liên kết thành viên",
  risk_weight: "Trọng số rủi ro",
  full_linkage: "Liên kết đầy đủ",
  total_risk_score: "Tổng điểm rủi ro",
  linkage_value: "Giá trị liên kết",
  source_occurrence_count: "Số lần xuất hiện nguồn",
  source_last_seen_at: "Lần xuất hiện cuối (nguồn)",
  target_occurrence_count: "Số lần xuất hiện mục tiêu",
  target_last_seen_at: "Lần xuất hiện cuối (mục tiêu)",
  member_linkage_detail: "Chi tiết liên kết thành viên",
  merchant_uid: "ID Người bán",
  merchant_no: "Số Người bán",
  slot_view: "Chế độ xem Slot",
  settlement_list_affiliate: "Danh sách thanh toán (Đối tác)",
  source: "Nguồn",
  earning_breakdown: "Phân Tích Thu Nhập",
  deposit_bonus: "Tiền thưởng tiền gửi",
  winlose_turnover: "WL/TO",
  cost: "Chi phí",
  promotion_voucher: "Voucher khuyến mãi",
  voucher_id: "ID Voucher",
  voucher_cash: "Kas Voucher",
  ticketvoucher: "Voucher ticket",
  ticket_voucher_list_member: "Danh sách voucher ticket (Thành viên)",
  ticket_voucher_list: "Danh sách voucher ticket",
  pending_review_funds_voucher: "Voucher ticket đang chờ & đang xem xét",
  all_pending_ticket_voucher: "Tất cả voucher ticket đang chờ",
  ticket_voucher_detail: "Chi tiết voucher ticket",
  raise_deposit_ticket_voucher: "Tạo voucher ticket nạp tiền",
  raise_deposit_ticket_voucher_gateway: "Tạo voucher ticket nạp tiền (gateway)",
  sos: "Nạp tiền SOS",
  sos_accumulate_deposit: "Nạp tiền SOS (tích lũy nạp)",
  greeting: "Lời chào",
  message: "Tin nhắn",
  get_voucher: "Lấy voucher",
  get_message: "Lấy tin nhắn",
  voucher: "Voucher",
  code: "Mã",
  redeemed_by: "Được đổi bởi",
  redeemed_by_operator: "Được đổi bởi (Nhân viên)",
  redeemed_at: "Được đổi lúc",
  created_at: "Tạo lúc",
  redeemed: "Đã đổi",
  member_sos_click_log: "Log click SOS thành viên",
  member_wallet_voucher_log: "Log voucher ví thành viên",
  member_voucher_redeemed_log: "Log đổi voucher thành viên",
  action_by_operator: "Thao tác bởi (Nhân viên)",
  redeem_cash: "Đổi tiền mặt",
  generate_voucher: "Tạo voucher",
  url_api_freecredit: "URL Callback Tín Dụng Miễn Phí",
  prefix_freecredit: "Tiền tố tín dụng miễn phí",
  free_credit_member: "Thành viên tín dụng miễn phí",
  free_credit_provider: "Nhà cung cấp tín dụng miễn phí",
  ticket_detail_fcp: "Chi tiết ticket nhà cung cấp tín dụng miễn phí",
  ticket_list_processed: "Danh sách ticket (Đã xử lý)",
  mission: "Nhiệm vụ",
  non_slot_view: "Chế độ xem không phải Slot",
  banner: "Banner",
  trigger: "Trigger",
  event_type: "Loại sự kiện",
  action_type: "Loại hành động",
  msg_greeting: "Lời chào (Tin nhắn)",
  msg_title: "Tiêu đề (Tin nhắn)",
  msg_body: "Nội dung (Tin nhắn)",
  send_message: "Gửi tin nhắn",
  promo_type: "Loại khuyến mãi",
  repeatable: "Lặp lại",
  rules: "Quy tắc",
  clear_outstanding_log: "Xóa nhật ký Outstanding",
  free_credit_withdrawal_amount: "Số tiền rút Free Credit",
  fc_withdrawal_amount: "Số tiền rút FC",
  frozen: "Đóng băng",
  transferred: "Đã chuyển",
  voucher_balance: "Số dư Voucher",
  adjust_voucher_balance: "Điều chỉnh số dư Voucher",
  free_game_provider: "Nhà cung cấp trò chơi miễn phí",
  check_free_spin: "Kiểm tra Free Spin",
  freespin_log: "Nhật ký Free Spin",
  current_round: "Vòng hiện tại",
  lines: "Dòng",
  expiry_interval_days: "Khoảng thời gian hết hạn (Ngày)",
  assign: "Chỉ định",
  game_code: "Mã trò chơi",
  clear_free_credit: "Xóa Free Credit",
  deposit_tier: "Cấp độ nạp tiền",
  point: "Điểm",
  top: "Trên",
  bottom: "Dưới",
  leaderboard_banner: "Banner Bảng Xếp Hạng",
  referral_banner: "Banner Giới Thiệu",
  tp_site: "URL Traffic Pool",
  current_icon: "Biểu tượng hiện tại",
  new_icon: "Biểu tượng mới",
  voucher_redeemed: "Voucher đã đổi",
  on_site: "Trên trang",
  exclude_own: "Loại trừ của chính mình",
  voucher_redeemed_detail: "Chi tiết Voucher đã đổi",
  gamification: "Gamification",
  reward_rain: "Reward Rain",
  total_claimed_amount: "Tổng số tiền đã nhận",
  min_amount: "Số tiền tối thiểu",
  max_amount: "Số tiền tối đa",
  reward_rain_session: "Phiên Reward Rain",
  reward_rain_session_claim: "Yêu cầu nhận thưởng Reward Rain",
  reward_amount: "Số tiền thưởng",
  cta: "CTA",
  api_email: "Email API",
  api_password: "Mật khẩu API",
  url_callback_voucher: "URL Callback Voucher",
  prefix_voucher: "Tiền tố Voucher",
  slide_show: "Trình Chiếu",
  ewallet_withdrawal: "Rút tiền từ ví điện tử",
  news: "Tin tức",
  slug: "Slug",
  preview_body: "Xem trước nội dung",
  full_body: "Nội dung đầy đủ",
  normal: "Bình thường",
  free_balance: "Số dư miễn phí",
  schema: "Lược đồ",

  tt_pixel_id: "ID pixel TT",
  tt_token: "Mã thông báo TT",

  free_spin_bulk_issue : "Free Spin (Phát hành hàng loạt)",
}